import { NotificationConfiguration } from '../notification.templates';

export const CR_VOTING_DUE_SOON_TEMPLATE: NotificationConfiguration = {
  inapp: `The voting is pending until <b>{dueDate}</b>`,
  email: {
    ctaKey: 'vote_now',
  },
};
